import type { PlatformMeDto, UiTheme } from '@ticarishift/api-client/platform';
import { api } from '../api/client.ts';

/**
 * Oturumdaki platform kullanıcısı (`GET /api/platform/me`): hesap, platform üyeliği (Platform kullanıcıları listesinde
 * kişinin kendi satırı), e-posta, rol şablonu, yetkileri ve tema tercihi. Menü ve eylemler sunucunun döndürdüğü yetkilerle süzülür;
 * arayüz rol → yetki tablosu tutmaz. Asıl denetim her uçta sunucudadır.
 */
export type PlatformIdentity = {
  readonly userId: string;
  readonly membershipId: string;
  readonly email: string;
  readonly role: string;
  readonly permissions: ReadonlySet<string>;
  readonly mfaEnabled: boolean;
  /** Tema tercihi (S23): Açık, Koyu ya da Sistem; panelle aynı kullanıcı kaydı. */
  readonly theme: UiTheme;
};

export function identityFrom(me: PlatformMeDto): PlatformIdentity {
  return {
    userId: me.userId,
    membershipId: me.membershipId,
    email: me.email,
    role: me.role,
    permissions: new Set(me.permissions),
    mfaEnabled: me.mfaEnabled,
    theme: me.theme,
  };
}

/** Oturumun kimliği; ağ, sunucu ya da oturum hatası çağırana gider (bağlantı ekranı ya da oturum açma). */
export async function resolveIdentity(signal?: AbortSignal): Promise<PlatformIdentity> {
  return identityFrom(await api.get('/api/platform/me', { signal }));
}
